import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../Text'
import { oneOfType, number, string } from 'prop-types';
import Number from '../Number';

const TableCountContainer = styled.div`
  text-align: right;
`

export default class TableCount extends Component {
  static propTypes = {
    count: oneOfType([number, string])
  }

  render () {
    const { count } = this.props
    return (
      <TableCountContainer>
        <Text text='Se encontraron ' />
        <Text text={<Number value={count || 0} isPrice={false} />} strong />
        <Text text=' registros' />
      </TableCountContainer>
    )
  }
}
